import {Select} from '@dropbox/dig-components/text_fields';
import {Box} from '@dropbox/dig-foundations';
import {getStatusOptions, StatusButtonIcon} from 'components/DSYS/StatusButtonIcon';
import statusStyles from 'components/shared/StatusModal.module.css';
import {t} from 'i18next';
import React from 'react';

import styles from './TrackerWorkstream.module.css';
import {getWorkstreamUpdateVisualStatus} from './utils';
import {useBlockOnTrackForReadiness} from './workstreamChecks';

export const WorkstreamUpdateStatusSelect = ({
  workstreamId,
  status,
  defaultStatus,
  onStatusChange,
}: {
  workstreamId: number;
  status: string;
  defaultStatus: string;
  onStatusChange: (status: string) => void;
}) => {
  const options = getStatusOptions();
  const isOnTrackBlockedByReadiness = useBlockOnTrackForReadiness(workstreamId);
  return (
    <Box className={styles.statusSelect} backgroundColor="Background Base">
      <Select
        id="status"
        defaultValue={defaultStatus}
        onChange={(val: string) => onStatusChange(val)}
        shouldShowOptionAccessory={false}
        value={status}
        withLeftAccessory={
          <StatusButtonIcon status={getWorkstreamUpdateVisualStatus(status)} includeArchived />
        }
        onClick={(e: React.SyntheticEvent) => {
          e.stopPropagation();
        }}
      >
        {options.map((statusOption) => (
          <Select.OptGroup key={statusOption.label} withLabel={t(statusOption.label)}>
            {statusOption.statusOptions.map(({value}) => {
              const shouldDisableOption = isOnTrackBlockedByReadiness && value === 'on_track';
              return (
                <Select.Option
                  aria-disabled={shouldDisableOption}
                  className={statusStyles.statusOptionOverride}
                  disabled={shouldDisableOption}
                  key={value}
                  value={value}
                  withAccessory={
                    <StatusButtonIcon
                      status={getWorkstreamUpdateVisualStatus(value)}
                      includeArchived
                    />
                  }
                >
                  {t(value).toString()}
                </Select.Option>
              );
            })}
          </Select.OptGroup>
        ))}
      </Select>
    </Box>
  );
};
